import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import "./defaultStyle.css";


const TopSocialProof = () => {
  const certificateData = useSelector(
    (store) => store?.certificateVerification?.certificateData
  );

  const Data = useMemo(()=> [
  {
    text: <>A hiring manager at <span className="font-bold">  Microsoft </span>just viewed <span className="font-bold"> {certificateData?.name?.split(" ")[0]}’s </span> certificate!</>,
    image:
      "https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Learners/Group%2023160.png?updatedAt=1751121003868",
  },
  {
    text: <>An HR from <span className="font-bold"> Swiggy </span> just verified <span className="font-bold">  {certificateData?.name?.split(" ")[0]}’s </span> certificate!</>,
    image:
      "https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Learners/Group%2023161.png?updatedAt=1751121003825",
  },
  {
    text: <>Someone from <span className="font-bold">  Meta  </span> downloaded <span className="font-bold">  {certificateData?.name?.split(" ")[0]}’s </span> certificate!</>,
    image:
      "https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Learners/Group%2023159.png?updatedAt=1751121003894",
  },
  {
    text: <>A recruiter from  <span className="font-bold"> TCS </span> is reviewing <span className="font-bold">  {certificateData?.name?.split(" ")[0]}’s </span> certificate!</>,
    image:
      "https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Learners/Group%2023162.png?updatedAt=1751121003818",
  },
  {
    text: <>An HR from <span className="font-bold"> Accenture </span> just opened <span className="font-bold">  {certificateData?.name?.split(" ")[0]}’s </span> certificate!</>,
    image:
      "https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Learners/Group%2023156.png?updatedAt=1751121003790",
  },
  {
    text: <>A LinkedIn <span className="font-bold"> recruiter </span> just checked <span className="font-bold">  {certificateData?.name?.split(" ")[0]}’s </span> certificate details!</>,
    image:
      "https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Learners/Group%2023158.png?updatedAt=1751121003801",
  },
  {
    text: <>A hiring expert at <span className="font-bold"> Flipkart </span> just looked into <span className="font-bold">  {certificateData?.name?.split(" ")[0]}’s </span> profile via certificate!</>,
    image:
      "https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Learners/Group%2023163.png?updatedAt=1751121003791",
  },
  {
    text: <>Someone from <span className="font-bold"> Google </span> reviewed <span className="font-bold">  {certificateData?.name?.split(" ")[0]}’s </span> certificate for a potential role!</>,
    image:
      "https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Learners/Group%2023157.png?updatedAt=1751121003078",
  }
  
] , [certificateData?.name]);

 const [randomItem, setRandomItem] = useState(null);

  useEffect(() => {
    const item = Data[Math.floor(Math.random() * Data.length)];
    setRandomItem(item);
  }, [Data]);

  
  return (
    <div className=" flex w-full items-center justify-center gap-2">
      <div className="relative h-[40px] w-[40px] flex-shrink-0 overflow-hidden rounded-full bg-white blur-[1px]">
        <img
          src={randomItem?.image}
          alt="profile"
          width={40}
          height={40}
          className="topbar h-auto w-full object-cover"
        />
      </div>

      
        <div className="rounded-r-xl rounded-t-xl bg-[#1D2B5A] px-4 py-2 text-[12px] font-normal text-white md:text-[14px]">
          {randomItem?.text}
        </div>
      
    </div>
  );
};

export default TopSocialProof;
